var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inspection-status-badge",class:_setup.badgeClasses},[_c('span',{staticClass:"inspection-status-badge__dot",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"inspection-status-badge__label"},[_vm._v(_vm._s(_setup.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }